// utils/privacyConsent.js
// 隐私政策授权状态（APP 首次启动弹窗）
// 应用市场审核要求：APP 首次打开必须先弹出隐私政策弹窗，用户点击"同意"之前
// 不得收集、传输任何个人信息，也不得进入应用主流程

const STORAGE_KEY = 'privacy_consent_accepted'

/**
 * 是否已同意隐私政策
 * @returns {boolean}
 */
export const hasPrivacyConsented = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (e) {
    // 存储不可用时视为未同意（下次启动会再次弹窗）
    return false
  }
}

/**
 * 记录用户已同意隐私政策（弹窗点"同意"时调用，只记一次）
 */
export const setPrivacyConsented = () => {
  try {
    localStorage.setItem(STORAGE_KEY, 'true')
  } catch (e) {
    // 存储不可用时忽略
  }
}
